import {
  Paper,
  Box,
  Typography,
  styled,
  Grid,
  Checkbox,
  checkboxClasses,
} from "@mui/material";
import ContentCard from "../Cards/ContentCard";
import CustomDrawer from "../Drawer";
import CustomTabs from "../Tabs/Tabs";

const CustomHeading = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "40px",
  lineHeight: "140%",
  letterSpacing: "0.01em",
  color: "#FFFFFF",
  position: "absolute",
  bottom: "340px",
});

const SubTitle = styled(Typography)({
  height: "20px",
  textAlign: "start",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "20px",
  color: "#ffffff",
  position: "absolute",
  bottom:"328px",
});

const SubTitle2 = styled(Typography)({
  height: "20px",
  textAlign: "start",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "20px",
  color: "#ffffff",
  position: "absolute",
  bottom: "328px",
  right: "43px",
});

const HeadingTypo = styled(Typography)({
  textAlign: "start",
  height: "36px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "32px",
  lineHeight: "150%",
  marginTop: "10px",
  letterSpacing: " 0.01em",
  color: "#000000",
});

const CustomButton = styled("a")({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "150%",
  letterSpacing: "0.015em",
  textDecorationLine: "underline",
  color: " #2B817B",
});

const SelectDishes = ({ onClose }) => {
  return (
    <CustomDrawer onClose={onClose}>
      <Paper
        style={{
          height: "297px",
          width: "100%",
          backgroundColor: "#333",
          backgroundImage: `url("https://thumbs.dreamstime.com/b/asian-food-background-various-ingredients-rustic-stone-top-view-vietnam-thai-cuisine-148762904.jpg")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Box style={{ paddingLeft: "20px" }}>
          <CustomHeading>Main Course</CustomHeading>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <SubTitle>Choose your prefered dishes</SubTitle>
            <SubTitle2 >6/30 Dishes</SubTitle2>
          </Box>
        </Box>
      </Paper>

      <CustomTabs
        pages={[
          {
            title: "Scheduled",
            children: <Dishes />,
          },
          {
            title: "General",
            children: <Dishes />,
          },
        ]}
      />
    </CustomDrawer>
  );
};

const Dishes = () => {
  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <HeadingTypo>Scheduled Dishes</HeadingTypo>
        <Box style={{ marginTop: "31px" }}>
          <CustomButton onClick={() => {}}>Select All</CustomButton>

          <Checkbox
            size="small"
            labelStyle={{ color: "#E1E1E6" }}
            iconStyle={{ color: "#E1E1E6" }}
            sx={{
              [`&, &.${checkboxClasses.checked}`]: {
                color: "#E1E1E6",
                fill: "#E1E1E6",
              },
            }}
            onChange={(e) => {
              console.log(e.target.value);
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={2} mt={2}>
        {[
          {
            heading: "Kabasa",
            subHeading: "Wed, 02 Nov 2021",
            onChecked: (e) => {
              console.log("e", e);
            },
            onClickView: (e) => {
              console.log("e", e);
            },
          },
          {
            heading: "Kabasa",
            subHeading: "Wed, 02 Nov 2021",
            onChecked: (e) => {
              console.log("e", e);
            },
            onClickView: (e) => {
              console.log("e", e);
            },
          },
        ].map((item) => (
          <Grid item sm={6} xs={6}>
            <ContentCard item={item} />
          </Grid>
        ))}
      </Grid>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <HeadingTypo>General Dishes</HeadingTypo>
        <Box style={{ marginTop: "31px" }}>
          <CustomButton onClick={() => {}}>Select All</CustomButton>

          <Checkbox
            size="small"
            labelStyle={{ color: "#E1E1E6" }}
            iconStyle={{ color: "#E1E1E6" }}
            sx={{
              [`&, &.${checkboxClasses.checked}`]: {
                color: "#E1E1E6",
                fill: "#E1E1E6",
              },
            }}
            onChange={(e) => {
              console.log(e.target.value);
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={2} mt={2}>
        {[
          {
            heading: "Kabasa",
            subHeading: "Wed, 02 Nov 2021",
            onChecked: (e) => {
              console.log("e", e);
            },
            onClickView: (e) => {
              console.log("e", e);
            },
          },
          {
            heading: "Kabasa",
            subHeading: "Wed, 02 Nov 2021",
            onChecked: (e) => {
              console.log("e", e);
            },
            onClickView: (e) => {
              console.log("e", e);
            },
          },
        ].map((item) => (
          <Grid item sm={6} xs={6}>
            <ContentCard item={item} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default SelectDishes;
